import dayjs from "dayjs";
import "dayjs/locale/ru.js";
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/customParseFormat";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.locale("ru");
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(quarterOfYear);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(weekOfYear);
dayjs.extend(advancedFormat);

// export { dayjs };
export const DatePlugin = {
  install(Vue) {
    Vue.prototype.$date = dayjs;
  },
};
